import React, { useState, useEffect } from 'react';
import { Spinner, Button } from 'react-bootstrap';
import { database, storage } from '../Firebase/firebase';

import { getAsanaWallTasksByProjectId, isUserAllowed, convertFirebaseTimestampToDate, convertOldDBtoNewDB } from '../Constants/Functions';
import { firebaseCollections, visibilityStatesArr } from '../Constants/Variables';
import { oldDB } from '../Constants/temp';
import AppNavbar from '../Components/AppNavbar';
import AddNewPostForm from '../Components/AddNewPostForm';
import TopInfluencersCard from '../Components/TopInfluencersCard';
import AppBanner from '../Components/AppBanner';
import Post from '../Components/Post';

import '../Styles/Pages/TheWall.scss';

function TheWall(props) {
    const [didDataFinishLoading, setDidDataFinishLoading] = useState(false);
    const [didFinishPagination, setDidFinishPagination] = useState(true);
    var [start, setStart] = useState(null);
    var [end, setEnd] = useState(null);
    const [posts, setPosts] = useState([]);
    let [allPostsArr, setAllPostsArr] = useState([]);
    const [listeners, setListeners] = useState([]);

    var storageRef = storage.ref();
    var provider = props.provider;
    var fbaccount = props.fbaccount;
    var account = provider.account;
    var paginationlimit = 20;
    var isLastPost = false;

    useEffect(() => {

        document.addEventListener('scroll', scrollingHandler);
        // var oldDB = JSON.parse(localStorage.getItem("oldDB"));
        // console.log(oldDB.slice(0, 10).filter(task => task.asanaId))
        // convertOldDBtoNewDB(oldDB.slice(0, 10).filter(task => task.asanaId))

        getPosts();
        // database.collection("FeedbackWall").get().then(function (querySnapshot) {
        //     var oldDB = []
        //     querySnapshot.forEach(function (doc) {
        //         oldDB.push(doc.data());
        //     });
        //     localStorage.setItem("oldDB", JSON.stringify(oldDB));
        // });
        return () => {
            detachListeners();
            document.removeEventListener('scroll', scrollingHandler);
        }
    }, []);

    const getPosts = () => {
        // query reference for the posts we want
        let ref = database.collection(firebaseCollections.thewall);
        // single query to get startAt snapshot
        ref.orderBy("timestamp", "desc")
            .limit(paginationlimit).get()
            .then((snapshots) => {

                // save startAt snapshot
                start = snapshots.docs[snapshots.docs.length - 1];
                // create listener using startAt snapshot (starting boundary)  
                if (start) {
                    let listener = ref.orderBy("timestamp")
                        .startAt(start)
                        .onSnapshot((snapshot) => {
                            // console.log("update made")
                            var testArr = [];
                            // append new posts to posts array
                            snapshot.forEach((post) => {
                                allPostsArr = allPostsArr.filter(x => x.id !== post.id);
                                allPostsArr.push(post.data());
                                testArr.push(post.data());
                            });
                            allPostsArr.sort((a, b) => b.timestamp - a.timestamp);
                            setPosts(allPostsArr);
                            setAllPostsArr(allPostsArr);
                            // setPosts((prevState) => {
                            //     var prevAllPostsArr = [];
                            //     prevState.forEach((post) => {
                            //         prevAllPostsArr = prevState.filter(x => x.id !== post.id);
                            //     })
                            //     return [...prevAllPostsArr, ...allPostsArr];
                            // });
                            setDidDataFinishLoading(true);
                        });
                    // add listener to list
                    listeners.push(listener);
                    setListeners(listeners);
                    setStart(start);
                    updatePostsAsanaTasks();
                } else {
                    setDidDataFinishLoading(true);
                }

            })
    }


    const getMorePosts = () => {

        if (start) {
            setDidFinishPagination(false);
            let ref = database.collection(firebaseCollections.thewall);
            // single query to get new startAt snapshot
            ref.orderBy("timestamp", "desc")
                .startAt(start)
                .limit(paginationlimit).get()
                .then((snapshots) => {
                    var docsCount = snapshots.docs.length;
                    if (docsCount !== paginationlimit) {
                        isLastPost = true;
                    }
                    // previous starting boundary becomes new ending boundary
                    end = start;
                    start = snapshots.docs[snapshots.docs.length - 1];
                    // create another listener using new boundaries     
                    let listener = ref.orderBy("timestamp")
                        .startAt(start).endBefore(end)
                        .onSnapshot((snapshot) => {
                            snapshot.forEach((post) => {
                                allPostsArr = allPostsArr.filter(x => x.id !== post.id);
                                allPostsArr.push(post.data());
                            });
                            allPostsArr.sort((a, b) => b.timestamp - a.timestamp);
                            // setPosts((prevState) => {
                            //     return [...prevState, ...allPostsArr];
                            // });
                            setPosts(allPostsArr);
                            setAllPostsArr(allPostsArr);

                        });
                    listeners.push(listener);
                    setListeners(listeners);
                    setStart(start);
                    setEnd(end);
                    setDidFinishPagination(true);
                    updatePostsAsanaTasks();
                });
        }

    }

    const updatePostsAsanaTasks = () => {
        setTimeout(() => {
            var asanaTasks = [];
            var postsWithAsanaTasks = allPostsArr.filter(post => post.asana);
            getAsanaWallTasksByProjectId("1194088099249937").then((data) => {
                asanaTasks = data;
                var batch = database.batch();

                for (let index = 0; index < postsWithAsanaTasks.length; index++) {
                    if (asanaTasks.length && postsWithAsanaTasks.length) {
                        var asanaTaskData = asanaTasks.filter((aTask) => { return aTask.id === postsWithAsanaTasks[index].asana.id })[0];
                        if (asanaTaskData) {
                            var dbref = database.collection(firebaseCollections.thewall).doc(postsWithAsanaTasks[index].id);
                            batch.update(dbref, { "asana": asanaTaskData });
                        }
                    }
                }

                batch.commit().then(() => {
                    // console.log("finished updating db asana task status")
                });
            })
        }, 2000);

    }

    // call to detach all listeners
    const detachListeners = () => {
        listeners.forEach(listener => listener());
    }

    const removePostHandler = (postId, imgId) => {

        //if post includes an image, delete the image file
        if (imgId) {
            // Create a reference to the file to delete
            var fileRef = storageRef.child('images/posts/' + imgId);

            // Delete the file
            fileRef.delete().then(function () {
                // File deleted successfully
            }).catch(function (error) {
                // Uh-oh, an error occurred!
            });
        }

        var allPostsArrIndex = allPostsArr.findIndex(x => x.id === postId);
        allPostsArr.splice(allPostsArrIndex, 1);
        setAllPostsArr(allPostsArr);
        database.collection(firebaseCollections.thewall).doc(postId).delete().then(function () {
            console.log("allPostsArrIndex: ", allPostsArrIndex)
            console.log("Feedback post successfully deleted!");
        }).catch(function (error) {
            console.error("There was a problem removing this post: ", error);
        });
    }


    const scrollingHandler = event => {
        const top = event.target.scrollingElement.scrollTop;
        const height = window.innerHeight;
        const offset = event.target.scrollingElement.offsetHeight;
        if (top > offset - height - 200) {
        if (!isLastPost) {
                // console.log("bottom");
                getMorePosts();
            } else {
                // console.log("no more pagination");
            }
        }

        if (top === 0) {
            // console.log("top");
        }
    }

    // var oldDB = JSON.parse(localStorage.getItem("oldDB"));
    // console.log("newdb: ", posts);
    // console.log("olddb: ", oldDB.slice(0, 10).filter(task => task.asanaId));

    // convertOldDBtoNewDB(oldDB.slice(0,10));
    return (
        didDataFinishLoading ?
            <div id="TheWall" className="TheWall">
                <AppNavbar {...props} />
                <AppBanner bannerimgsrc="/images/thewall_cover.png" showheadline={true} title="The Wall" tagline="Anything on your mind? Share it with us, share it with everyone!" />
                <div className="TheWall--Body">
                    <div className="TheWall--Body--Top-Section">
                        <div className="TheWall--Body--Top-Section--Column">

                        </div>
                        <AddNewPostForm {...props} />
                        <div className="TheWall--Body--Top-Section--Column">
                            <TopInfluencersCard />
                        </div>
                    </div>
                    {
                        posts.filter((post) => { return visibilityStatesArr[post.visibility] === "Public" || post.user.uid === account.accountIdentifier || isUserAllowed(fbaccount.role, "viewPrivatePosts") }).map((post, index) => {
                            return <Post fbaccount={fbaccount} key={index} post={post} onRemove={removePostHandler} {...props} />
                        })
                    }
                    {
                        didFinishPagination ?
                            null :
                            <div className="TheWall--Pagination--Spinner">
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    role="status"
                                    aria-hidden="true"
                                />
                            </div>
                    }
                </div>
            </div> :
            (<div className="TheWall--Spinner">
                <Spinner
                    as="span"
                    animation="grow"
                    role="status"
                    aria-hidden="true"
                />
                <span>LOADING POSTS...</span>
            </div>)
    )
}

export default TheWall;